export default __webpack_public_path__ + "static/media/small_logo_icon.5777a20e.svg";